import './estilo.css';
import {
  aceitarContraproposta,
  carregarJson,
  clubePorId,
  comprarJunior,
  comprarExterno,
  contratarLivre,
  externoPorId,
  definirApelido,
  dispensarJunior,
  ELENCO_MAX,
  assumirClube,
  PAISES_MUNDO,
  clubesDaLiga,
  encerrarTemporada,
  convitesDeEmprego,
  propostasDeEmprego,
  saldoDemissivel,
  expandirEstadio,
  clubesParaEscolher,
  clubesDaDivisao,
  ligaDoHumano,
  paisDaLiga,
  divisaoDoHumano,
  incluirClubesNaCopa,
  novoJogo,
  novoJogoLiga,
  resumoTemporada,
  pagarEmprestimo,
  pegarEmprestimo,
  precoPedido,
  procurarCompradores,
  promoverJunior,
  proporCompra,
  PENALTI_TENSAO_MS,
  Rng,
  estadoDaPartida,
  minutoEm,
  montarLinhaTempo,
  salvarJson,
  simularRodada,
  temporadaEncerrada,
  venderPara,
  type Posicao,
} from '../core';
import { definirSom, somApito, somContusao, somExpulsao, somFimDeJogo, somGolMarcado, somGolSofrido, somIntervalo, somPerdeu, somSuspense } from './som';
import { FILTROS_VAZIOS, app, type PartidaUi, carregarLocal, carregarPreferencias, erroTexto, humano, jogoAtual, salvarLocal, salvarPreferencias, existeSaveLocal, descartarSaveLocal } from './app';
import { dlgFinancas, dlgJuniores, dlgLeilao, dlgPedidos, dlgTecnicos } from './abas';
import { LIBERTADORES_LIBERADA } from './recursos';
import { dlgAgenda, dlgDemissao, dlgEstadio, dlgHistoria, dlgNegociacao, dlgOfertas, dlgOpcoes, dlgProcura, dlgTimes, dlgTabelas, executarProcura } from './dialogos';
import { aplicarEscalar, aposJogar, dlgEscalar, escClique, escMudar, iniciarEscalar } from './escalar';
import { clubesDaEscolha, telaInicio, telaNovo } from './inicio';
import { chaveDinheiro, formatarNumero, textoExtenso, type CampoDinheiro } from './dinheiro';
import { marcarSemEscudo, marcarSemRosto } from './icones';
import { dinheiroCurto, esc } from './util';
import { iniciarArrastar } from './arrastar';
import { iniciarTema } from './tema';
import { definirGanchoSalvou } from './app';
import { iniciarNotificacoes } from './notificacoes';
import { confirmarSubstituicoes, guardarEstadoDaRodada, podeSubstituir, taticaEmJogo } from './solo-ao-vivo';
import { definirSeloImportado, estadoSelo, selarAgora, selarSePreciso, verificarArquivo } from './selo';
import { dlgConvites, sessaoDaConta, acaoOnline, carregarJogoDaConta, desconectarOnline, enviar, enviarPrecos, salvarJogoNaConta, escolherClubeOnline, iniciarOnline, mudarEntrada, onlineAcao, sairOnline, telaDemitido, telaEntrada, telaLobby } from './online';
import { disputaDoJogo, partidaDoUsuario, telaPartida } from './partida';
import { iniciarChat } from './chat';
import { pedirPersistencia } from './armazenamento';
import { dlgTreino, treinoAcao, treinoMudar } from './treino';

/** Online: manda o plano de treino ao servidor (no solo ele já vale e vai no save). */
function enviarTreino(): void {
  if (app.online) {
    enviar({ tipo: 'treino', treino: humano().treino as NonNullable<ReturnType<typeof humano>['treino']> }).catch((erro: unknown) => {
      app.mensagem = erroTexto(erro);
      desenhar();
    });
  } else salvarLocal();
}
import { carregarPerfil, carregarRanking, contaArquivo, contaClique, dlgConta, dlgLoja, dlgRanking, ligarConta } from './conta';
import { decorridoDaRodada, dlgPausa, iniciarPausa, pausaClique, pausaMudar, restoDaPausa } from './pausa';
import { telaPrincipal } from './principal';

const raiz = document.getElementById('app') as HTMLElement;
let relogio: number | undefined;

// ---- desenho -----------------------------------------------------------------------------------

function dialogoAtual(): string {
  let html = '';
  switch (app.dialogo) {
    case 'tabelas':
      html = dlgTabelas();
      break;
    case 'estadio':
      html = dlgEstadio();
      break;
    case 'procura':
      html = dlgProcura();
      break;
    case 'times':
      html = dlgTimes();
      break;
    case 'escalar':
      html = dlgEscalar();
      break;
    case 'agenda':
      html = dlgAgenda();
      break;
    case 'historia':
      html = dlgHistoria();
      break;
    case 'opcoes':
      html = dlgOpcoes();
      break;
    case 'juniores':
      html = dlgJuniores();
      break;
    case 'financas':
      html = dlgFinancas();
      break;
    case 'tecnicos':
      html = dlgTecnicos();
      break;
    case 'leilao':
      html = dlgLeilao();
      break;
    case 'pedidos':
      html = dlgPedidos();
      break;
    case 'pausa':
      html = dlgPausa();
      break;
    case 'treino':
      html = dlgTreino();
      break;
    case 'demissao':
      html = dlgDemissao();
      break;
    case 'convites':
      html = dlgConvites();
      break;
    case 'conta':
      html = dlgConta();
      break;
    case 'loja':
      html = dlgLoja();
      break;
    case 'ranking':
      html = dlgRanking();
      break;
    default:
      html = '';
  }
  if (app.ofertasVenda) html += dlgOfertas();
  if (app.negociacao) html += dlgNegociacao();
  return html;
}

/** Conta e loja abrem por cima de qualquer tela, inclusive as de antes do jogo. */
const dialogoDaConta = (): string => (app.dialogo === 'conta' ? dlgConta() : app.dialogo === 'loja' ? dlgLoja() : '');

function montarHtml(): string {
  if (app.tela === 'inicio') return telaInicio(existeSaveLocal()) + dialogoDaConta();
  if (app.tela === 'novo') return telaNovo() + dialogoDaConta();
  if (app.tela === 'online') return telaEntrada();
  if (app.tela === 'lobby') return telaLobby();
  if (app.tela === 'jogo' && app.online?.visao?.sala.iniciada && app.online.visao.eu.emprego) return telaDemitido();
  if (app.tela === 'partida') return telaPartida() + (app.dialogo === 'pausa' ? dialogoAtual() : '');
  const dialogo = dialogoAtual();
  // o aviso da tela principal ficaria escondido atrás da janela aberta: com uma janela aberta ele sobe como faixa por cima dela
  // (janelas que já mostram o próprio aviso, como Treino e Leilão, não repetem)
  const aviso =
    app.mensagem && dialogo && !dialogo.includes("aviso-bf dentro")
      ? `<div class="aviso-bf toast-msg" role="status">${esc(app.mensagem)}<button class="x" data-a="fechar-msg" aria-label="Fechar aviso">×</button></div>`
      : "";
  return `<div class="bf">${telaPrincipal()}${dialogo}${aviso}</div>`;
}

/** Áreas com rolagem própria: a posição é guardada antes de redesenhar e devolvida depois. */
const ROLAGEM = '.tabela-elenco, .rolavel, .bf-overlay, .bf-dlg, .dlg-corpo, .pt-eventos, .campo-fut';

let ultimoHtml = '';
let ultimaChave = '';
let desenhoAgendado = false;

/**
 * Redesenha a tela só se algo mudou, sem repetir animação de entrada e mantendo a rolagem.
 * Vários pedidos no mesmo instante viram um só desenho (no próximo quadro).
 */
function desenhar(): void {
  if (desenhoAgendado) return;
  desenhoAgendado = true;
  const executar = (): void => {
    if (!desenhoAgendado) return;
    desenhoAgendado = false;
    desenharAgora();
  };
  requestAnimationFrame(executar);
  // aba oculta não dispara quadros de animação: o temporizador garante o desenho mesmo assim
  window.setTimeout(executar, 50);
}

// ---- janelas arrastáveis: segure a barra de título (ou a faixa de cima) e mova, como uma janela do sistema -------
let posJanela = { x: 0, y: 0 };

function aplicarPosJanela(): void {
  const valor = posJanela.x || posJanela.y ? `${posJanela.x}px ${posJanela.y}px` : '';
  raiz.querySelectorAll<HTMLElement>('.bf-dlg').forEach((el) => {
    el.style.translate = valor;
  });
}

document.addEventListener('pointerdown', (ev) => {
  if (ev.pointerType !== 'mouse' || ev.button !== 0) return;
  const alvo = ev.target as HTMLElement | null;
  const dlg = alvo?.closest<HTMLElement>('.bf-dlg');
  if (!alvo || !dlg || alvo.closest('button, input, select, textarea, a, label, [data-a], .rolavel')) return;
  const r = dlg.getBoundingClientRect();
  if (!alvo.closest('.dlg-tit, .conta-cab, .loja-cab, h2') && ev.clientY - r.top > 40) return;
  const ini = { x: ev.clientX, y: ev.clientY, px: posJanela.x, py: posJanela.y };
  const mover = (m: PointerEvent): void => {
    let x = ini.px + m.clientX - ini.x;
    let y = ini.py + m.clientY - ini.y;
    // a barra de título nunca sai da tela: sempre dá para pegar a janela de volta
    const esq = r.left + (x - ini.px);
    const topo = r.top + (y - ini.py);
    x += Math.min(Math.max(esq, 80 - r.width), window.innerWidth - 80) - esq;
    y += Math.min(Math.max(topo, 0), window.innerHeight - 40) - topo;
    posJanela = { x, y };
    aplicarPosJanela();
  };
  const soltar = (): void => {
    document.removeEventListener('pointermove', mover);
    document.removeEventListener('pointerup', soltar);
    document.body.style.userSelect = '';
  };
  document.body.style.userSelect = 'none';
  document.addEventListener('pointermove', mover);
  document.addEventListener('pointerup', soltar);
});

function desenharAgora(): void {
  document.body.dataset.tela = app.tela;
  let html: string;
  try {
    html = montarHtml();
  } catch (erro) {
    // um save que passou na validação mas quebra a tela não pode travar o jogo de novo a cada abertura: descarta e volta ao início
    console.error('falha ao desenhar o jogo; descartando o save', erro);
    pararRelogio();
    app.jogo = null;
    app.previa = null;
    app.partida = null;
    app.online = null;
    app.dialogo = null;
    app.tela = 'inicio';
    app.mensagem = 'Este save não pôde ser aberto (dados inválidos) e foi descartado. Comece um novo jogo.';
    void descartarSaveLocal();
    html = montarHtml();
  }
  const chave = `${app.tela}|${app.dialogo ?? ''}|${app.ofertasVenda ? 'o' : ''}${app.negociacao ? 'n' : ''}`;
  if (html === ultimoHtml && raiz.childElementCount > 0) return;
  // a animação de entrada só toca quando a tela ou a janela mudam; cliques dentro da mesma janela não a repetem
  const mesma = chave === ultimaChave;
  const rolagens = [...raiz.querySelectorAll<HTMLElement>(ROLAGEM)].map((el) => [el.scrollTop, el.scrollLeft] as const);
  const janelaY = window.scrollY;
  raiz.classList.toggle('sem-anim', mesma);
  raiz.innerHTML = html;
  // janela nova volta ao centro; redesenhos da mesma janela mantêm onde o jogador a deixou
  if (!mesma) posJanela = { x: 0, y: 0 };
  aplicarPosJanela();
  if (mesma) {
    raiz.querySelectorAll<HTMLElement>(ROLAGEM).forEach((el, i) => {
      const r = rolagens[i];
      if (r) {
        el.scrollTop = r[0];
        el.scrollLeft = r[1];
      }
    });
    if (window.scrollY !== janelaY) window.scrollTo(0, janelaY);
  }
  ultimoHtml = html;
  ultimaChave = chave;
}

// ---- relógio da partida ao vivo ---------------------------------------------------------------

function pararRelogio(): void {
  if (relogio !== undefined) window.clearTimeout(relogio);
  relogio = undefined;
}

function agendarRelogio(): void {
  pararRelogio();
  const p = app.partida;
  if (!p || p.fase === 'fim' || p.pausado) return;
  const rapida = app.velocidade === 3;
  const espera = p.fase === 'penaltis'
    ? p.disputa?.etapa === 'tensao' ? (rapida ? 1000 : 1800) : rapida ? 800 : 1300
    : p.suspense
      ? p.suspense.etapa === 'tensao' ? (rapida ? 1800 : 3200) : rapida ? 1000 : 1700
      : p.fase === 'intervalo' ? 1400 : rapida ? 45 : 140;
  relogio = window.setTimeout(passoRelogio, espera);
}

/** Intervalo e fim de jogo valem depois que o lance do minuto (pênalti) termina. */
function ajustarFase(p: PartidaUi, fimPrimeiroTempo: number, total: number): void {
  if (p.minuto === fimPrimeiroTempo) p.fase = 'intervalo';
  if (p.minuto >= total) {
    p.minuto = total;
    p.fase = 'fim';
    // confronto da Copa decidido nos pênaltis: a disputa acontece ao vivo antes do resumo
    const pj = partidaDoUsuario();
    if (disputaDoJogo(jogoAtual(), p.rodada.rodada, pj.mandante, pj.visitante)) {
      p.fase = 'penaltis';
      p.disputa = { reveladas: 0, etapa: 'tensao' };
    }
  }
}

function somDaFase(p: PartidaUi): void {
  const fase: PartidaUi['fase'] = p.fase; // ajustarFase pode ter mudado a fase
  if (fase === 'intervalo') somIntervalo();
  else if (fase === 'penaltis') somApito();
  else if (fase === 'fim') somFimDeJogo();
}

/** Uma etapa da disputa de pênaltis: a tensão antes da cobrança e depois o resultado dela. */
function passoDisputa(p: PartidaUi): void {
  const pj = partidaDoUsuario();
  const c = disputaDoJogo(jogoAtual(), p.rodada.rodada, pj.mandante, pj.visitante);
  const d = p.disputa;
  if (!c?.cobrancas || !d) {
    p.fase = 'fim';
    p.disputa = undefined;
    return;
  }
  if (d.etapa === 'tensao') {
    const cob = c.cobrancas[d.reveladas];
    d.etapa = 'resultado';
    d.reveladas++;
    if (cob) {
      const meuClube = jogoAtual().humanoId;
      const ladoMeu = (c.a === meuClube ? 0 : 1) as 0 | 1;
      if (!cob.convertido) somPerdeu();
      else if (cob.lado === ladoMeu) somGolMarcado();
      else somGolSofrido();
    }
  } else if (d.reveladas >= c.cobrancas.length) {
    p.fase = 'fim';
    p.disputa = undefined;
    somFimDeJogo();
  } else {
    d.etapa = 'tensao';
  }
}

/** Toca o som do lance, do ponto de vista do técnico que está jogando. */
function somDoLance(lado: 0 | 1, golOuPerdeu: 'gol' | 'perdeu'): void {
  const meu = partidaDoUsuario().mandante === jogoAtual().humanoId ? 0 : 1;
  if (golOuPerdeu === 'perdeu') somPerdeu();
  else if (lado === meu) somGolMarcado();
  else somGolSofrido();
}

function passoRelogio(): void {
  const p = app.partida;
  if (!p || app.tela !== 'partida') return;
  const r = partidaDoUsuario().resultado;

  if (p.fase === 'penaltis') {
    passoDisputa(p);
    desenhar();
    agendarRelogio();
    return;
  }

  if (p.suspense) {
    if (p.suspense.etapa === 'tensao') {
      p.suspense.etapa = 'resultado';
      somDoLance(p.suspense.ev.lado, p.suspense.ev.detalhe === 'gol' ? 'gol' : 'perdeu');
    } else {
      p.suspense = undefined;
      ajustarFase(p, r.fimPrimeiroTempo, r.totalMinutos);
      somDaFase(p);
    }
    desenhar();
    agendarRelogio();
    return;
  }

  if (p.fase === 'intervalo') p.fase = 'ao-vivo';
  p.minuto++;
  const lances = r.eventos.filter((ev) => ev.minuto === p.minuto);
  const penalti = lances.find((ev) => ev.tipo === 'penalti');
  if (penalti) {
    // pênalti: apito, tempo de tensão e só então o resultado (gol, defendeu ou para fora)
    p.suspense = { ev: penalti, etapa: 'tensao' };
    somApito();
    somSuspense(app.velocidade === 3 ? 1800 : 3200);
  } else {
    for (const ev of lances) {
      if (ev.tipo === 'gol') somDoLance(ev.lado, 'gol');
      else if (ev.tipo === 'vermelho') somExpulsao();
      else if (ev.tipo === 'lesao') somContusao();
    }
    ajustarFase(p, r.fimPrimeiroTempo, r.totalMinutos);
    somDaFase(p);
  }
  desenhar();
  agendarRelogio();
}

function jogarRodada(): void {
  const e = jogoAtual();
  guardarEstadoDaRodada(e); // para refazer a rodada se o técnico substituir durante a partida
  const rodada = simularRodada(e);
  const indice = rodada.partidas.findIndex((p) => p.mandante === e.humanoId || p.visitante === e.humanoId);
  salvarLocal();
  aposJogar();
  if (rodada.contratosRenovados?.length) app.mensagem = `Contratos renovados: ${rodada.contratosRenovados.join(', ')}.`;
  if (rodada.treino?.length) app.mensagem = `${app.mensagem ? app.mensagem + ' ' : ''}Treino: ${rodada.treino.slice(0, 3).join(' ')}`;
  app.dialogo = null;
  app.negociacao = null;
  app.ofertasVenda = null;
  if (indice < 0) {
    app.tela = 'jogo';
    return;
  }
  abrirPartida(rodada, indice);
}

/** Abre a tela da partida ao vivo da rodada odada (índice da partida do usuário em rodada.partidas). */
// ---- partida online: o relógio é do servidor ----------------------------------------------------

let ultimoEstadoOnline: { minuto: number; fase: string; suspense?: string } | null = null;

function agendarRelogioOnline(): void {
  pararRelogio();
  relogio = window.setTimeout(passoOnline, 50);
}

/** Toca os sons dos lances que o relógio acabou de atravessar (só uma vez cada). */
function sonsDaTransicao(anterior: number, novo: number): void {
  const r = partidaDoUsuario().resultado;
  const temPenalti = r.eventos.some((ev) => ev.tipo === 'penalti' && ev.minuto > anterior && ev.minuto <= novo);
  for (const ev of r.eventos) {
    if (ev.minuto <= anterior || ev.minuto > novo) continue;
    if (ev.tipo === 'gol' && !temPenalti) somDoLance(ev.lado, 'gol');
    else if (ev.tipo === 'vermelho') somExpulsao();
    else if (ev.tipo === 'lesao') somContusao();
  }
}

/** Atualiza só o tempo que resta na janela de pausa/intervalo, sem redesenhar nada. */
function atualizarContagemPausa(): void {
  const resto = Math.ceil(restoDaPausa() / 1000);
  const tempo = raiz.querySelector<HTMLElement>('.bf-dlg.pausa .pausa-tempo');
  if (tempo && tempo.textContent !== `${resto}s`) tempo.textContent = `${resto}s`;
  tempo?.closest('.pausa-cab')?.classList.toggle('urgente', resto <= 10);
}

function passoOnline(): void {
  const p = app.partida;
  if (!p?.online || app.tela !== 'partida') return;
  const e = jogoAtual();
  const pj = partidaDoUsuario();
  const decorrido = decorridoDaRodada();
  const linha = montarLinhaTempo(e, p.rodada.rodada, p.rodada.partidas, app.online?.visao?.sala.aoVivo?.ritmo);
  const est = estadoDaPartida(e, p.rodada.rodada, pj, linha, decorrido);
  p.minutoGlobal = minutoEm(linha, decorrido);
  {
    // andamento fino: a barra de progresso corre dentro de cada minuto em vez de pular de minuto em minuto
    const m = est.minuto;
    const total = pj.resultado.totalMinutos;
    let prog = est.fase === "fim" ? 1 : 0;
    if (est.fase !== "fim" && m > 0 && total > 0) {
      const ini = linha.inicios[m] ?? 0;
      const prox = linha.inicios[m + 1] ?? linha.fim;
      const frac = prox > ini ? Math.min(1, Math.max(0, (decorrido - ini) / (prox - ini))) : 0;
      prog = Math.min(1, (m - 1 + frac) / total);
    }
    p.progresso = prog;
  }

  const anterior = p.minuto;
  const eraEtapaPen = p.suspense?.etapa;
  const eraFase = p.fase;
  // quem só acompanha (não joga a rodada) não ouve os sons do "meu jogo": o jogo que aparece é o primeiro da lista, não o dele
  const mudo = Boolean(p.espectador);
  if (!mudo && est.minuto > anterior) sonsDaTransicao(anterior, est.minuto);
  p.minuto = est.minuto;
  p.fase = est.fase;
  const evPen = est.suspense ? pj.resultado.eventos.find((ev) => ev.tipo === 'penalti' && ev.minuto === est.suspense?.minuto) : undefined;
  p.suspense = est.suspense && evPen ? { ev: evPen, etapa: est.suspense.etapa } : undefined;
  if (mudo) {
    /* sem sons */
  } else if (p.suspense && !eraEtapaPen) {
    somApito();
    somSuspense(PENALTI_TENSAO_MS);
  } else if (p.suspense?.etapa === 'resultado' && eraEtapaPen === 'tensao') somDoLance(p.suspense.ev.lado, p.suspense.ev.detalhe === 'gol' ? 'gol' : 'perdeu');
  const disputaAnterior = p.disputa;
  p.disputa = est.disputa;
  if (!mudo && est.disputa && est.disputa.etapa === 'resultado' && (!disputaAnterior || disputaAnterior.reveladas !== est.disputa.reveladas || disputaAnterior.etapa !== 'resultado')) {
    const c = disputaDoJogo(e, p.rodada.rodada, pj.mandante, pj.visitante);
    const cob = c?.cobrancas?.[est.disputa.reveladas - 1];
    if (c && cob) {
      const ladoMeu = (c.a === e.humanoId ? 0 : 1) as 0 | 1;
      if (!cob.convertido) somPerdeu();
      else if (cob.lado === ladoMeu) somGolMarcado();
      else somGolSofrido();
    }
  }
  const faseAgora: PartidaUi['fase'] = p.fase;
  if (!mudo && eraFase !== faseAgora) {
    if (faseAgora === 'intervalo') somIntervalo();
    else if (faseAgora === 'penaltis') somApito();
    else if (faseAgora === 'fim') somFimDeJogo();
  }

  // a pausa venceu pelo relógio do servidor: fecha a janela de substituições
  if (app.dialogo === 'pausa' && restoDaPausa() <= 0) {
    app.dialogo = null;
    app.pausa = null;
  }
  ultimoEstadoOnline = { minuto: p.minuto, fase: p.fase };
  // com a janela de pausa/intervalo aberta o jogo está parado: refazer a tela toda a cada passo fecharia o seletor de formação,
  // soltaria o arrasto e piscaria tudo. Só a contagem regressiva é atualizada.
  if (app.dialogo === 'pausa' && raiz.querySelector('.bf-dlg.pausa')) atualizarContagemPausa();
  else desenhar();
  // a partida do técnico acabou e o servidor já encerrou a rodada: para o relógio
  if (faseAgora === 'fim' && !app.online?.visao?.sala.aoVivo) return;
  agendarRelogioOnline();
}

function abrirPartida(rodada: ReturnType<typeof simularRodada>, indice: number): void {
  const total = (rodada.partidas[indice] as (typeof rodada.partidas)[number]).resultado.totalMinutos;
  app.partida = { rodada, indice, minuto: app.velocidade === 0 ? total : 0, fase: app.velocidade === 0 ? 'fim' : 'ao-vivo', ritmo: 140 };
  app.tela = 'partida';
  agendarRelogio();
}

/** No modo online a rodada é simulada no servidor; quando ela chega, mostra a partida do técnico. */
function exibirRodadaOnline(): void {
  const e = jogoAtual();
  const rodada = e.ultimaRodada;
  if (!rodada) return;
  const indice = rodada.partidas.findIndex((p) => p.mandante === e.humanoId || p.visitante === e.humanoId);
  if (indice < 0) {
    // o clube não joga esta rodada: fica na tela principal, sem fechar as janelas que o técnico está usando (o botão
    // "Ver os jogos" da lateral abre os detalhes se ele quiser)
    if (app.tela !== 'partida') app.tela = 'jogo';
    return;
  }
  app.dialogo = null;
  app.negociacao = null;
  app.ofertasVenda = null;
  if (app.online?.visao?.sala.aoVivo) {
    // rodada ao vivo: o minuto sai do relógio do servidor, igual para todos os técnicos
    app.partida = { rodada, indice, minuto: 0, fase: 'ao-vivo', ritmo: 140, online: true };
    app.tela = 'partida';
    ultimoEstadoOnline = null;
    agendarRelogioOnline();
    return;
  }
  abrirPartida(rodada, indice);
}

// ---- ações ---------------------------------------------------------------------------------------

function novaPrevia(): void {
  const semente = (Math.random() * 2 ** 32) >>> 0;
  if (app.novo.ligaMundo && app.novo.semMundo) {
    // só a liga estrangeira escolhida, com os clubes da planilha
    app.previa = novoJogoLiga(semente, app.novo.ligaMundo, 0);
    const lista = [...app.previa.clubes].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    app.novo.clubeId = (lista[Math.floor(lista.length / 2)] ?? lista[0])?.id ?? 0;
    return;
  }
  // Série A e Série B juntas (com acesso e rebaixamento) e, por padrão, as 13 ligas estrangeiras com os clubes de verdade;
  // os seletores "País" e "Campeonato" só escolhem de qual liga sai o clube do técnico
  app.previa = novoJogo(semente, 0, 20, 'a', app.novo.copa !== false, true, LIBERTADORES_LIBERADA && app.novo.copa !== false && app.novo.libertadores !== false, app.novo.semMundo !== true);
  // marcou que NÃO quer a Libertadores: ela também não entra sozinha na virada da temporada
  if (LIBERTADORES_LIBERADA && app.novo.libertadores === false) app.previa.semLibertadores = true;
  const nomes = clubesDaEscolha(app.previa).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
  app.novo.clubeId = (nomes[Math.floor(nomes.length / 2)] ?? nomes[0])?.id ?? 0;
}

function iniciarJogo(): void {
  const p = app.previa;
  if (!p) return;
  const nome = (document.getElementById('novo-nome') as HTMLInputElement | null)?.value.trim() || 'Técnico';
  const escolhaveis = clubesDaEscolha(p);
  const id = app.novo.aleatorio ? (escolhaveis[Math.floor(Math.random() * escolhaveis.length)] as (typeof escolhaveis)[number]).id : app.novo.clubeId;
  p.humanoId = id;
  for (const c of p.clubes) c.humano = c.id === id;
  if (!p.ligaMundo) {
    p.divisao = divisaoDoHumano(p) === 2 ? 'b' : 'a';
    incluirClubesNaCopa(p, [id]); // com a copa no mesmo save, o clube escolhido sempre a disputa (clube estrangeiro não a disputa)
  }
  p.tecnico = nome;
  app.jogo = p;
  app.previa = null;
  app.tela = 'jogo';
  app.dialogo = null;
  app.jogadorSel = null;
  app.mensagem = '';
  salvarLocal();
}

function abrirDialogo(d: string): void {
  app.mensagem = '';
  app.dialogo = d as typeof app.dialogo;
  const e = jogoAtual();
  if (d === 'times') {
    // técnico num clube estrangeiro (jogo com o mundo inteiro): a lista abre no país e na liga dele
    const liga = ligaDoHumano(e);
    app.times = { clubeId: e.humanoId, jogadorId: null, ...(liga ? { pais: paisDaLiga(liga)?.nome, liga } : {}) };
  }
  if (d === 'tabelas') {
    app.tabelas.rodada = Math.max(0, e.rodada - 1);
    app.tabelas.temporada = undefined;
    // técnico num clube estrangeiro: as Tabelas abrem na liga dele (aba internacional)
    const liga = ligaDoHumano(e);
    if (liga) {
      app.tabelas.aba = 'internacional';
      app.tabelas.pais = paisDaLiga(liga)?.nome;
      app.tabelas.liga = liga;
      app.tabelas.clubeLiga = undefined;
      app.tabelas.rodadaMundo = undefined;
    }
  }
  if (d === 'procura' && app.procura.resultados.length === 0) app.procura.resultados = executarProcura();
}

/** Jogo com o mundo inteiro: ao trocar de país ou liga na aba Times, mostra o primeiro clube (por nome) dela. */
function timesPrimeiroClube(ligaId: string | undefined): void {
  const e = jogoAtual();
  const lista = ligaId === 'br-a' || ligaId === 'br-b' ? clubesDaDivisao(e, ligaId === 'br-b' ? 2 : 1) : e.clubes.filter((c) => c.liga === ligaId);
  const primeiro = [...lista].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))[0];
  if (primeiro) app.times = { ...app.times, clubeId: primeiro.id, jogadorId: null };
}

function recarregarListas(): void {
  if (app.dialogo === 'procura') {
    const sel = app.procura.sel;
    app.procura.resultados = executarProcura();
    if (sel && !app.procura.resultados.some((r) => r.jogadorId === sel.jogadorId)) app.procura.sel = null;
  }
}

function lerFiltros(): void {
  const v = (id: string): string => (document.getElementById(id) as HTMLInputElement | null)?.value ?? '';
  const n = (id: string, padrao: number): number => {
    const x = Number(v(id));
    return Number.isFinite(x) && v(id) !== '' ? x : padrao;
  };
  app.procura.filtros = {
    nome: v('f-nome'),
    posicao: v('f-pos') as Posicao | '',
    lado: v('f-lado') as 'E' | 'D' | '',
    forcaMin: n('f-fmin', 1),
    forcaMax: n('f-fmax', 100),
    idadeMin: n('f-imin', 16),
    idadeMax: n('f-imax', 45),
    car1: n('f-car1', -1),
    car2: n('f-car2', -1),
    valor: v('f-valor'),
    livres: (document.getElementById('f-livres') as HTMLInputElement | null)?.checked ?? false,
    campeonato: v('f-camp') || 'br',
  };
}

/**
 * Exporta o save. Com conta logada e o servidor no ar, o arquivo vai assinado: `{ webfoot: 2, selo, estado }` (o `estado` é o texto
 * do save, exatamente o que o servidor assinou). Ao importar, o servidor confere se o selo é dele e se nada foi alterado.
 * Sem conta ou sem rede, sai o save puro, sem assinatura (vale para jogar, mas o servidor não concede conquistas a ele).
 */
async function exportar(): Promise<void> {
  const e = jogoAtual();
  const texto = salvarJson(e);
  let conteudo = texto;
  let nota = 'Save exportado (sem assinatura: entre numa conta para assinar).';
  if (sessaoDaConta()) {
    const r = await selarAgora(texto);
    if (r) {
      conteudo = JSON.stringify({ webfoot: 2, selo: r.selo, estado: texto });
      nota = 'Save exportado e assinado pela sua conta.';
    } else nota = `Save exportado sem assinatura (o servidor não assinou: ${estadoSelo.texto || 'sem conexão'}).`;
  }
  const blob = new Blob([conteudo], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `webfoot-temporada${e.temporada}-rodada${e.rodada}.json`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  app.mensagem = nota;
  desenhar();
}

/** Antes de encerrar a temporada: manda o estado do fim dela para o servidor creditar as últimas vitórias (a resposta chega depois). */
function selarAntesDeEncerrar(): void {
  void selarAgora();
}

function clicarArquivo(): void {
  (document.getElementById('arquivo') as HTMLInputElement | null)?.click();
}

function acao(nome: string, d: DOMStringMap, alvo: HTMLElement): void {
  // começar ou carregar um jogo solo encerra a ligação com a sala (a sessão fica salva para reconectar)
  if (app.online && (nome === 'novo-jogo' || nome === 'jogo-salvo' || nome === 'importar-inicio')) desconectarOnline();
  // ---- conta e loja (valem em qualquer tela, com ou sem jogo aberto)
  if (nome === 'abrir' && (d.d === 'conta' || d.d === 'loja')) {
    app.mensagem = '';
    app.dialogo = d.d;
    void carregarPerfil().then(desenhar);
    return;
  }
  if (nome === 'fechar' && (app.dialogo === 'conta' || app.dialogo === 'loja')) {
    app.dialogo = null;
    app.mensagem = '';
    return;
  }
  if (nome === 'abrir' && d.d === 'ranking') {
    app.mensagem = '';
    app.dialogo = 'ranking';
    void carregarRanking().then(desenhar);
    return;
  }
  // sair da conta leva ao menu principal (em sala online, deixa a sala: o online exige login)
  if (nome === 'conta-sair' || nome === 'online-conta-sair') {
    if (nome === 'conta-sair') contaClique(nome, d);
    else acaoOnline(nome, d);
    pararRelogio();
    if (app.online) sairOnline();
    app.previa = null;
    app.dialogo = null;
    app.mensagem = '';
    app.tela = 'inicio';
    return;
  }
  if (nome.startsWith('conta-')) return contaClique(nome, d);
  // ---- início
  if (nome === 'novo-jogo') {
    pararRelogio();
    novaPrevia();
    app.tela = 'novo';
    app.dialogo = null;
    app.mensagem = '';
    return;
  }
  if (nome === 'outro-mundo') return novaPrevia();
  if (nome === 'online-conta-salvar' && app.jogo) return salvarJogoNaConta(salvarJson(app.jogo));
  if (nome === 'online-conta-carregar') {
    return carregarJogoDaConta((texto) => {
      app.jogo = carregarJson(texto, { externo: true });
      app.dialogo = null;
      app.tela = 'jogo';
      app.mensagem = 'Jogo carregado da sua conta.';
      salvarLocal();
    });
  }
  if (nome.startsWith('online-') && nome !== 'online-pronto') return acaoOnline(nome, d);
  if ((nome === 'voltar-inicio' || nome === 'menu-inicial') && app.online) return sairOnline();
  if (nome === 'voltar-inicio' || nome === 'menu-inicial') {
    app.previa = null;
    app.dialogo = null;
    app.mensagem = '';
    app.tela = 'inicio';
    return;
  }
  if (nome === 'iniciar-jogo') return iniciarJogo();
  if (nome === 'jogo-salvo') {
    // o save vem do IndexedDB (assíncrono): a tela é redesenhada quando ele chega
    void carregarLocal().then((salvo) => {
      if (!salvo) {
        app.mensagem = 'Nenhum jogo salvo encontrado.';
      } else {
        app.jogo = salvo;
        app.tela = 'jogo';
        app.jogadorSel = null;
        app.mensagem = '';
      }
      desenhar();
    });
    return;
  }
  if (nome === 'importar-inicio' || nome === 'importar') return clicarArquivo();

  // ---- partida ao vivo
  if (nome === 'ver-jogo' && app.partida) {
    // abre os detalhes de outro jogo da rodada (ou volta para o do técnico); o relógio continua o mesmo
    const i = Number(d.i);
    app.partida.verIndice = Number.isInteger(i) && app.partida.rodada.partidas[i] && i !== app.partida.indice ? i : undefined;
    return;
  }
  if (nome === 'ver-rodada') {
    // o técnico não joga esta rodada: abre os detalhes dos jogos dela (ao vivo no online) sem ser obrigado a ir
    const e = jogoAtual();
    const rodada = e.ultimaRodada;
    const primeiro = rodada?.partidas[0];
    if (!rodada || !primeiro) {
      app.mensagem = 'Ainda não há jogos desta competição para ver.';
      return;
    }
    app.dialogo = null;
    if (app.online?.visao?.sala.aoVivo) {
      app.partida = { rodada, indice: 0, minuto: 0, fase: 'ao-vivo', ritmo: 140, online: true, espectador: true };
      app.tela = 'partida';
      ultimoEstadoOnline = null;
      agendarRelogioOnline();
    } else {
      app.partida = { rodada, indice: 0, minuto: primeiro.resultado.totalMinutos, fase: 'fim', ritmo: 140, espectador: true };
      app.tela = 'partida';
    }
    return;
  }
  // jogo solo: pausa a partida em qualquer momento (inclusive no suspense do pênalti e na disputa) e continua de onde parou
  if (nome === 'pausa-local' && app.partida && !app.partida.online) {
    app.partida.pausado = !app.partida.pausado;
    if (app.partida.pausado) pararRelogio();
    else agendarRelogio();
    return;
  }
  // jogo solo, partida pausada: abre a janela de substituições e tática (sem limite de tempo)
  if (nome === 'pausa-substituir' && app.partida && !app.partida.online && podeSubstituir()) {
    const p = app.partida;
    const total = partidaDoUsuario().resultado.totalMinutos;
    iniciarPausa(Math.min(Math.max(1, p.minuto), total - 1), 0, false, false, taticaEmJogo());
    return;
  }
  // confirmar a janela no solo: refaz a rodada com as mudanças e a partida volta de onde parou
  if (nome === 'pausa-ok' && app.partida && !app.partida.online && app.pausa?.local) {
    const erro = confirmarSubstituicoes();
    if (erro) {
      app.mensagem = `Mudança não aplicada: ${erro}.`;
      return;
    }
    app.pausa = null;
    app.dialogo = null;
    app.partida.pausado = false;
    agendarRelogio();
    return;
  }
  if (nome === 'pular-partida' && app.partida) {
    app.partida.pausado = false;
    pararRelogio();
    app.partida.suspense = undefined;
    app.partida.disputa = undefined;
    app.partida.minuto = partidaDoUsuario().resultado.totalMinutos;
    app.partida.fase = 'fim';
    return;
  }
  if (nome === 'ritmo-partida') {
    app.velocidade = app.velocidade === 3 ? 1 : 3;
    salvarPreferencias();
    agendarRelogio();
    return;
  }
  if (nome === 'pausa-sai' || nome === 'pausa-entra' || nome === 'pausa-desfazer') return pausaClique(nome, d);
  if (nome === 'tr-ind-add' || nome === 'tr-ind-del') {
    if (treinoAcao(nome, d)) enviarTreino();
    return;
  }
  if (nome === 'mg-pular' && app.partida && d.k) {
    // mini-game do pênalti sofrido: guarda o canto escolhido (só vale uma vez por lance)
    if (app.partida.minigame?.chave !== d.k) app.partida.minigame = { chave: d.k, escolha: Number(d.c) };
    return;
  }
  if (nome === 'continuar') {
    pararRelogio();
    app.partida = null;
    app.tela = 'jogo';
    if (temporadaEncerrada(jogoAtual())) app.mensagem = 'Temporada encerrada! Abra Opções para encerrá-la e começar a próxima.';
    return;
  }

  if (!app.jogo) return;
  const e = app.jogo;
  app.mensagem = nome.startsWith('esc-') ? app.mensagem : '';
  if (app.online && onlineAcao(nome, d)) return;

  // ---- menu e janelas
  if (nome === 'abrir') return abrirDialogo(d.d ?? '');
  if (nome === 'fechar') {
    app.dialogo = null;
    app.negociacao = null;
    app.ofertasVenda = null;
    app.escalar = null;
    return;
  }
  if (nome === 'fechar-neg') {
    app.negociacao = null;
    return;
  }
  if (nome === 'fechar-msg') return;
  if (nome === 'ordenar') {
    const col = d.col ?? '';
    app.ordem = app.ordem?.col === col ? { col, asc: !app.ordem.asc } : { col, asc: col === 'nome' || col === 'pos' };
    return;
  }
  if (nome === 'sel-jog') {
    app.jogadorSel = Number(d.id);
    return;
  }
  if (nome === 'tab-aba') {
    app.tabelas.aba = d.p === 'internacional' ? 'internacional' : 'nacional';
    return;
  }
  if (nome === 'tab-painel') {
    app.tabelas.painel = (d.p as 'estatisticas' | 'rodadas') ?? 'estatisticas';
    return;
  }

  // ---- estádio
  if (nome === 'expandir') {
    try {
      const custo = expandirEstadio(humano());
      app.mensagem = `Obra concluída: +1.000 lugares.`;
      void custo;
    } catch (erro) {
      app.mensagem = `Não foi possível ampliar: ${erroTexto(erro)}.`;
    }
    return salvarLocal();
  }

  // ---- escalação
  if (nome === 'escalar') {
    iniciarEscalar();
    app.dialogo = 'escalar';
    return;
  }
  if (nome.startsWith('esc-') && nome !== 'esc-voltar' && nome !== 'esc-jogar') return escClique(nome, d);
  if (nome === 'esc-voltar') {
    if (aplicarEscalar()) {
      app.dialogo = null;
      app.escalar = null;
      salvarLocal();
    }
    return;
  }
  if (nome === 'esc-jogar') {
    if (aplicarEscalar()) jogarRodada();
    return;
  }

  // ---- mercado
  if (nome === 'proc-sel') {
    app.procura.sel = { jogadorId: Number(d.id), clubeId: d.club ? Number(d.club) : null };
    return;
  }
  if (nome === 'proc-buscar') {
    lerFiltros();
    app.procura.resultados = executarProcura();
    app.procura.sel = null;
    return;
  }
  if (nome === 'proc-reset') {
    app.procura.filtros = FILTROS_VAZIOS();
    app.procura.resultados = executarProcura();
    app.procura.sel = null;
    return;
  }
  if (nome === 'times-clube') {
    app.times = { clubeId: Number(d.id), jogadorId: null, pais: app.times.pais, liga: app.times.liga };
    return;
  }
  if (nome === 'times-externo') {
    app.times = { clubeId: null, jogadorId: null, externo: Number(d.id), pais: app.times.pais, liga: app.times.liga };
    return;
  }
  if (nome === 'times-mundo') {
    const p = PAISES_MUNDO.find((x) => x.nome === app.times.pais);
    const ligaId = app.times.liga && p?.ligas.some((l) => l.id === app.times.liga) ? app.times.liga : p?.ligas[0]?.id;
    const clube = ligaId ? clubesDaLiga(ligaId)[Number(d.id)] : undefined;
    if (clube) app.times.mundo = clube.nome;
    return;
  }
  if (nome === 'times-jog') {
    app.times.jogadorId = Number(d.id);
    return;
  }
  if (nome === 'comprar') {
    const id = Number(d.id);
    const clubeId = Number(d.club);
    const dono = clubePorId(e, clubeId);
    const j = dono.elenco.find((x) => x.id === id);
    if (!j) return;
    const r = proporCompra(e, e.humanoId, id, precoPedido(j, dono));
    app.mensagem = r.tipo === 'aceita' ? `Contratação fechada: ${j.nome} por ${r.valor.toLocaleString('pt-BR')}.` : `Não foi possível comprar: ${r.tipo === 'recusada' ? r.motivo : 'o clube pediu outro valor'}.`;
    if (r.tipo === 'aceita') {
      app.procura.sel = null;
      app.times.jogadorId = null;
    }
    recarregarListas();
    return salvarLocal();
  }
  if (nome === 'oferta') {
    const id = Number(d.id);
    const dono = clubePorId(e, Number(d.club));
    const j = dono.elenco.find((x) => x.id === id);
    if (j) app.negociacao = { jogadorId: id, livre: false, oferta: precoPedido(j, dono), resposta: null };
    return;
  }
  if (nome === 'proposta' && app.negociacao) {
    const r = proporCompra(e, e.humanoId, app.negociacao.jogadorId, app.negociacao.oferta);
    if (r.tipo === 'aceita') {
      app.mensagem = `Contratação fechada por ${r.valor.toLocaleString('pt-BR')}.`;
      app.negociacao = null;
      app.procura.sel = null;
      app.times.jogadorId = null;
      recarregarListas();
      salvarLocal();
    } else app.negociacao.resposta = r;
    return;
  }
  if (nome === 'aceitar-contra' && app.negociacao) {
    try {
      aceitarContraproposta(e, e.humanoId, app.negociacao.jogadorId, Number(d.valor));
      app.mensagem = `Contratação fechada por ${Number(d.valor).toLocaleString('pt-BR')}.`;
      app.negociacao = null;
      app.procura.sel = null;
      app.times.jogadorId = null;
      recarregarListas();
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível fechar: ${erroTexto(erro)}.`;
    }
    return;
  }
  if (nome === 'comprar-externo') {
    try {
      const x = externoPorId(Number(d.id));
      const preco = comprarExterno(e, e.humanoId, Number(d.id));
      app.mensagem = `Contratação fechada: ${x?.nome ?? 'jogador'} por ${preco.toLocaleString('pt-BR')}.`;
      app.procura.sel = null;
      recarregarListas();
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível contratar: ${erroTexto(erro)}.`;
    }
    return;
  }
  if (nome === 'contratar-livre') {
    try {
      const j = e.livres.find((x) => x.id === Number(d.id));
      contratarLivre(e, e.humanoId, Number(d.id));
      app.mensagem = `${j?.nome ?? 'Jogador'} contratado como livre.`;
      app.procura.sel = null;
      recarregarListas();
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível contratar: ${erroTexto(erro)}.`;
    }
    return;
  }
  if (nome === 'din-ajuste') {
    const campo = d.campo ?? '';
    const id = d.id === undefined ? undefined : Number(d.id);
    const min = Number(d.min ?? 0);
    const ref = Number(d.ref ?? 0);
    const atual = lerDinheiro(campo, id);
    const delta = d.delta ?? '0';
    const novo = delta === 'min' ? min : delta === 'ref' ? ref : Math.max(min, atual + Number(delta));
    gravarDinheiro(campo, Math.max(0, Math.round(novo)), id);
    return;
  }
  if (nome === 'leiloar') {
    if (!app.online) {
      app.mensagem = 'Leilão só existe no modo online (entre técnicos humanos).';
      return;
    }
    app.ofertasVenda = { jogadorId: Number(d.id), ofertas: [], soLeilao: true };
    return;
  }
  if (nome === 'vender') {
    const rng = new Rng(e.rngEstado);
    app.ofertasVenda = { jogadorId: Number(d.id), ofertas: procurarCompradores(e, e.humanoId, Number(d.id), rng) };
    e.rngEstado = rng.estado;
    return salvarLocal();
  }
  if (nome === 'vender-p') {
    try {
      const j = humano().elenco.find((x) => x.id === Number(d.id));
      venderPara(e, e.humanoId, Number(d.id), Number(d.comp), Number(d.valor));
      app.mensagem = `Venda fechada: ${j?.nome ?? 'jogador'} por ${Number(d.valor).toLocaleString('pt-BR')}.`;
      app.ofertasVenda = null;
      app.jogadorSel = null;
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível vender: ${erroTexto(erro)}.`;
    }
    return;
  }

  // ---- juniores
  if (nome === 'jr-sel') {
    app.juniores.jogadorId = Number(d.id);
    return;
  }
  if (nome === 'jr-promover' || nome === 'jr-dispensar' || nome === 'jr-apelido' || nome === 'jr-comprar') {
    const me = humano();
    const lista = me.juniores ?? [];
    const alvoId = app.juniores.clubeId ?? me.id;
    const dono = clubePorId(e, alvoId);
    const j = (dono.juniores ?? []).find((x) => x.id === app.juniores.jogadorId) ?? (dono.juniores ?? [])[0];
    if (!j) return;
    try {
      if (nome === 'jr-promover') {
        promoverJunior(me, j.id, ELENCO_MAX);
        app.mensagem = `${j.nome} foi promovido ao time principal.`;
      } else if (nome === 'jr-dispensar') {
        if (!window.confirm(`Deseja dispensar o junior ${j.nome}?`)) return;
        dispensarJunior(me, j.id);
        app.mensagem = `${j.nome} foi dispensado.`;
      } else if (nome === 'jr-apelido') {
        definirApelido(j, app.juniores.apelido);
        app.juniores.apelido = '';
        app.mensagem = `Apelido definido: ${j.nome}.`;
      } else {
        const preco = comprarJunior(me, dono, j.id);
        app.mensagem = `${j.nome} contratado para a academia por ${preco.toLocaleString('pt-BR')}.`;
      }
      if (nome !== 'jr-apelido') app.juniores.jogadorId = null;
      void lista;
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível: ${erroTexto(erro)}.`;
    }
    return;
  }

  // ---- finanças
  if (nome === 'emp-pegar' || nome === 'emp-pagar') {
    try {
      if (nome === 'emp-pegar') pegarEmprestimo(humano());
      else pagarEmprestimo(humano());
      salvarLocal();
    } catch (erro) {
      app.mensagem = `Não foi possível: ${erroTexto(erro)}.`;
    }
    return;
  }
  if (nome === 'hist-aba') {
    app.historia.aba = d.p === 'trofeus' ? 'trofeus' : 'campeoes';
    return;
  }

  // ---- opções
  if (nome === 'salvar') {
    salvarLocal();
    if (!app.mensagem) app.mensagem = 'Jogo salvo.';
    return;
  }
  if (nome === 'exportar') return void exportar();
  if (nome === 'ate-fim') {
    while (!temporadaEncerrada(e)) simularRodada(e);
    app.dialogo = null;
    app.mensagem = 'Temporada simulada até o fim. Abra Opções para encerrá-la.';
    return salvarLocal();
  }
  if (nome === 'encerrar' && temporadaEncerrada(e)) {
    // saldo de -R$ 10 milhões ou pior ao fim da temporada: o técnico é demitido e escolhe um clube que o queira
    if (saldoDemissivel(e)) {
      app.demissao = { saldo: humano().caixa, de: humano().nome, propostas: propostasDeEmprego(e) };
      app.dialogo = 'demissao';
      return salvarLocal();
    }
    // campeão ou entre os 3 primeiros: clubes maiores (de qualquer país) podem convidar o técnico; ele aceita ou segue onde está
    const convites = convitesDeEmprego(e);
    if (convites.length > 0) {
      app.demissao = { saldo: humano().caixa, de: humano().nome, propostas: convites, convite: true };
      app.dialogo = 'demissao';
      return salvarLocal();
    }
    selarAntesDeEncerrar();
    const reg = encerrarTemporada(e);
    app.dialogo = null;
    app.mensagem = resumoTemporada(e, reg);
    return salvarLocal();
  }
  if (nome === 'convite-recusar' && app.demissao?.convite && temporadaEncerrada(e)) {
    app.demissao = null;
    selarAntesDeEncerrar();
    const reg = encerrarTemporada(e);
    app.dialogo = null;
    app.mensagem = `Você recusou os convites e seguiu no clube. ${resumoTemporada(e, reg)}`;
    return salvarLocal();
  }
  if (nome === 'demissao-adiar') {
    app.demissao = null;
    app.dialogo = null;
    return;
  }
  if (nome === 'demissao-aceitar' && app.demissao && temporadaEncerrada(e)) {
    // a temporada se encerra com o clube antigo (resumo e prêmios são dele); o novo clube entra já na temporada seguinte
    selarAntesDeEncerrar();
    const reg = encerrarTemporada(e);
    const resumo = resumoTemporada(e, reg);
    const novo = assumirClube(e, Number(d.id));
    const convite = app.demissao.convite === true;
    app.demissao = null;
    app.dialogo = null;
    app.jogadorSel = null;
    app.mensagem = `${convite ? 'Você aceitou o convite e assumiu' : 'Você foi demitido e assumiu'} o ${novo.nome}. ${resumo}`;
    return salvarLocal();
  }
  void alvo;
}

// ---- eventos -------------------------------------------------------------------------------------

// clicar no fundo escuro (fora da janela) fecha o modal, se a opção estiver ligada; o clique tem de começar e terminar no fundo,
// para não fechar ao soltar o mouse depois de selecionar texto ou arrastar a janela
let apertouNoFundo = false;
raiz.addEventListener('pointerdown', (ev) => {
  apertouNoFundo = (ev.target as HTMLElement).classList.contains('bf-overlay');
});
raiz.addEventListener('click', (ev) => {
  const el = ev.target as HTMLElement;
  if (app.fecharAoClicarFora && apertouNoFundo && el.classList.contains('bf-overlay')) {
    apertouNoFundo = false;
    el.querySelector<HTMLElement>('.dlg-x')?.click();
    return;
  }
  apertouNoFundo = false;
  const alvo =(ev.target as HTMLElement).closest<HTMLElement>('[data-a]');
  if (!alvo || alvo.hasAttribute('disabled')) return;
  const nome = alvo.dataset.a ?? '';
  try {
    acao(nome, alvo.dataset, alvo);
  } catch (erro) {
    app.mensagem = `Erro: ${erroTexto(erro)}`;
  }
  if (nome !== 'importar' && nome !== 'importar-inicio' && nome !== 'conta-foto-enviar') desenhar();
  if (alvo.closest('.bf-ctx')) fecharMenu();
});

raiz.addEventListener('keydown', (ev) => {
  if (ev.key !== 'Enter' && ev.key !== ' ') return;
  const alvo = ev.target as HTMLElement;
  if (alvo.matches('tr[data-a]')) {
    ev.preventDefault();
    alvo.click();
  }
});

/** Maior arquivo de save aceito na importação (um save com centenas de clubes tem poucos MB). */
const TAMANHO_MAXIMO_SAVE = 60 * 1024 * 1024;

function carregarArquivo(arquivo: File): void {
  if (arquivo.size > TAMANHO_MAXIMO_SAVE) {
    app.mensagem = 'Falha ao importar: o arquivo é grande demais para ser um save do jogo.';
    desenhar();
    return;
  }
  const leitor = new FileReader();
  leitor.onload = async () => {
    try {
      let texto = String(leitor.result);
      let situacao = 'Save importado (sem assinatura: o servidor não concede conquistas a este jogo).';
      let selo: string | null = null;
      // arquivo assinado: { webfoot: 2, selo, estado } — o servidor confere se o selo é dele e se o conteúdo não foi alterado
      if (texto.trimStart().startsWith('{"webfoot"')) {
        const env = JSON.parse(texto) as { webfoot?: number; selo?: unknown; estado?: unknown };
        if (env.webfoot !== 2 || typeof env.selo !== 'string' || typeof env.estado !== 'string') throw new Error('arquivo assinado inválido');
        texto = env.estado;
        const v = await verificarArquivo(env.selo, texto);
        if (v.autentico) {
          selo = env.selo;
          situacao = `Save importado: assinatura confirmada (conta ${v.conta}, temporada ${v.temporada}, rodada ${v.rodada}).`;
        } else situacao = 'ATENÇÃO: a assinatura deste save não confere (arquivo alterado ou de outro servidor). Você pode jogar, mas ele não gera conquistas nem XP.';
      }
      app.jogo = carregarJson(texto, { externo: true });
      app.previa = null;
      app.tela = 'jogo';
      app.dialogo = null;
      app.jogadorSel = null;
      app.mensagem = situacao;
      definirSeloImportado(selo);
      salvarLocal();
      // save autêntico: sela já, antes de jogar mais, para a conta continuar dele (o selo vale para o conteúdo exato importado)
      if (selo) void selarAgora(texto);
    } catch (erro) {
      app.mensagem = `Falha ao importar: ${erroTexto(erro)}`;
    }
    desenhar();
  };
  leitor.readAsText(arquivo);
}

raiz.addEventListener('change', (ev) => {
  const alvo = ev.target as HTMLInputElement;
  if (alvo.id === 'arquivo' && alvo.files?.[0]) return carregarArquivo(alvo.files[0]);
  if (alvo.id === 'conta-foto-arquivo' && alvo.files?.[0]) return contaArquivo(alvo.files[0]);
  if (alvo.dataset.money !== undefined) return;
  const campo = alvo.dataset.ch;
  if (!campo) return;
  const valor = alvo.type === 'checkbox' ? String(alvo.checked) : alvo.value;

  if (campo === 'novo-clube') app.novo.clubeId = Number(valor);
  else if (campo === 'novo-aleatorio') app.novo.aleatorio = valor === 'true';
  else if (campo.startsWith('esc-')) escMudar(campo, valor);
  else if (campo === 'velocidade') {
    app.velocidade = Number(valor) as 0 | 1 | 3;
    salvarPreferencias();
  } else if (campo.startsWith('tr-')) {
    if (treinoMudar(campo, valor)) enviarTreino();
  } else if (campo === 'novo-pais') {
    const pais = PAISES_MUNDO.find((p) => p.nome === valor);
    app.novo.ligaMundo = pais?.ligas[0]?.id;
    novaPrevia();
  } else if (campo === 'novo-mundo') {
    app.novo.semMundo = valor !== 'true';
    novaPrevia();
  } else if (campo === 'novo-liga') {
    app.novo.ligaMundo = valor;
    novaPrevia();
  } else if (campo === 'novo-div') {
    app.novo.divisao = valor === 'b' ? 'b' : 'a';
    novaPrevia();
  } else if (campo === 'novo-lib') {
    app.novo.libertadores = valor === 'true';
    novaPrevia();
  } else if (campo === 'novo-copa') {
    app.novo.copa = valor === 'true';
    novaPrevia();
  } else if (campo === 'fechar-fora') {
    app.fecharAoClicarFora = valor === 'sim';
    salvarPreferencias();
  } else if (campo === 'demissao-caixa') {
    // regra do jogo solo, guardada no save: "Ligada" é o padrão (campo ausente)
    if (valor === 'nao') jogoAtual().semDemissaoPorCaixa = true;
    else delete jogoAtual().semDemissaoPorCaixa;
    salvarLocal();
  } else if (campo === 'minigame') {
    app.minigame = valor === 'sim';
    salvarPreferencias();
  } else if (campo === 'tab-clube-it') {
    app.tabelas.clubeLiga = valor || undefined;
  } else if (campo === 'rodada-mundo') {
    app.tabelas.rodadaMundo = Number(valor);
  } else if (campo === 'tab-temp') {
    const t = Number(valor);
    app.tabelas.temporada = t === jogoAtual().temporada ? undefined : t;
  } else if (campo === 'times-pais') {
    app.times.pais = valor === 'Brasil' ? undefined : valor;
    app.times.liga = undefined;
    app.times.mundo = undefined;
    if (jogoAtual().mundo) timesPrimeiroClube(valor === 'Brasil' ? 'br-a' : PAISES_MUNDO.find((p) => p.nome === valor)?.ligas[0]?.id);
  } else if (campo === 'times-liga') {
    app.times.liga = valor;
    app.times.mundo = undefined;
    if (jogoAtual().mundo) timesPrimeiroClube(valor);
  } else if (campo === 'tab-pais') {
    app.tabelas.pais = valor || undefined;
    app.tabelas.liga = undefined;
    app.tabelas.clubeLiga = undefined;
  } else if (campo === 'tab-liga') {
    app.tabelas.liga = valor || undefined;
    app.tabelas.clubeLiga = undefined;
    app.tabelas.rodadaMundo = undefined;
  } else if (campo === 'tab-camp') {
    app.tabelas.campeonato = valor === 'b' ? 'b' : valor === 'copa' ? 'copa' : valor === 'lib' ? 'lib' : valor === 'sul' ? 'sul' : 'a';
  } else if (campo.startsWith('pz-')) {
    pausaMudar(campo, valor);
  } else if (campo === 'som') {
    definirSom(valor === 'sim');
    salvarPreferencias();
  } else if (campo === 'rodada-tab') app.tabelas.rodada = Number(valor);
  else if (campo === 'leilao-valor') {
    app.leilao.valores[Number(alvo.dataset.id)] = valor;
    return; // não redesenha: o campo continua com o valor digitado
  } else if (campo === 'leilao-preco') {
    app.leilao.preco = valor;
    return;
  } else if (campo === 'leilao-duracao') app.leilao.duracao = valor;
  else if (campo === 'online-clube') {
    escolherClubeOnline(valor);
    return;
  } else if (campo === 'online-camp' || campo === 'online-prazo' || campo === 'online-unid' || campo === 'online-pers' || campo === 'online-max') {
    if (!mudarEntrada(campo, valor)) return; // o campo do prazo personalizado mantém o que foi digitado
  } else if (campo === 'jr-clube') app.juniores = { clubeId: Number(valor), jogadorId: null, apelido: app.juniores.apelido };
  else if (campo === 'hist-clube') app.historia.clubeId = Number(valor);
  else if (campo === 'jr-apelido') {
    app.juniores.apelido = valor;
    return; // não redesenha: o campo continua com o texto digitado
  }
  else if (campo === 'oferta' && app.negociacao) {
    app.negociacao.oferta = Math.max(0, Math.round(Number(valor) || 0));
    return; // não redesenha: o campo continua com o valor digitado
  } else if (app.jogo && campo === 'preco') {
    const i = Number(alvo.dataset.i);
    humano().precos[i] = Math.min(500, Math.max(1, Math.round(Number(valor) || 1)));
    if (app.online) enviarPrecos();
    salvarLocal();
  } else if (app.jogo && campo === 'sugeridos') {
    humano().usarPrecosSugeridos = valor === 'true';
    if (app.online) enviarPrecos();
    salvarLocal();
  }
  desenhar();
});

// ---- campos de dinheiro (R$ com milhar, valor por extenso e botões de ajuste) ---------------------

function lerDinheiro(campo: string, id?: number): number {
  if (campo === 'leilao-preco') return Number(app.leilao.preco) || 0;
  if (campo === 'leilao-valor') return Number(app.leilao.valores[id ?? -1] ?? 0) || 0;
  if (campo === 'oferta') return app.negociacao?.oferta ?? 0;
  return 0;
}

function gravarDinheiro(campo: string, n: number, id?: number): void {
  if (campo === 'leilao-preco') app.leilao.preco = String(n);
  else if (campo === 'leilao-valor') app.leilao.valores[id ?? -1] = String(n);
  else if (campo === 'oferta' && app.negociacao) app.negociacao.oferta = n;
}

// o nome do técnico digitado na tela inicial é lido ao iniciar; guarda enquanto digita sem redesenhar
raiz.addEventListener('input', (ev) => {
  const alvo = ev.target as HTMLInputElement;
  if (alvo.id === 'novo-nome') app.novo.nome = alvo.value;
  if (alvo.dataset.money !== undefined) {
    // só dígitos; reformata com ponto de milhar e atualiza o texto por extenso sem redesenhar a tela
    const n = Math.min(99_999_999_999, Number(alvo.value.replace(/\D/g, '')) || 0);
    const id = alvo.dataset.id === undefined ? undefined : Number(alvo.dataset.id);
    gravarDinheiro(alvo.dataset.money, n, id);
    alvo.value = formatarNumero(n);
    const ext = raiz.querySelector<HTMLElement>(`[data-ext="${chaveDinheiro(alvo.dataset.money as CampoDinheiro, id)}"]`);
    if (ext) ext.textContent = textoExtenso(n);
  }
});

// ---- menu do botão direito (ou toque longo) nas linhas de jogador ---------------------------------

interface ItemMenu {
  rotulo: string;
  acao?: string;
  dados?: Record<string, string>;
  /** motivo para estar desativado (aparece como dica) */
  desativado?: string;
}

function fecharMenu(): void {
  document.querySelector('.bf-ctx')?.remove();
}

function itensDoMenu(linha: HTMLElement): { titulo: string; itens: ItemMenu[] } | null {
  const e = app.jogo;
  if (!e || app.tela !== 'jogo') return null;
  const id = Number(linha.dataset.id);
  const acaoLinha = linha.dataset.a;
  const eu = humano();
  let jogadorId = id;
  let clubeId: number | null = null;
  if (acaoLinha === 'sel-jog') clubeId = eu.id;
  else if (acaoLinha === 'times-jog') {
    if (app.times.externo !== undefined) return null; // clube de outra divisão: só consulta
    clubeId = app.times.clubeId ?? eu.id;
  }
  else if (acaoLinha === 'proc-sel') clubeId = linha.dataset.club ? Number(linha.dataset.club) : null;
  else if (acaoLinha === 'jr-sel') return null;
  else return null;
  jogadorId = id;
  const livre = clubeId === null;
  const dono = livre ? null : clubePorId(e, clubeId as number);
  const jogador = livre ? e.livres.find((x) => x.id === jogadorId) : dono?.elenco.find((x) => x.id === jogadorId);
  if (!jogador) return null;
  const itens: ItemMenu[] = [];
  if (livre) {
    itens.push({ rotulo: 'Contratar como livre', acao: 'contratar-livre', dados: { id: String(jogador.id) } });
  } else if (dono && dono.id === eu.id) {
    itens.push({ rotulo: 'Vender jogador', acao: 'vender', dados: { id: String(jogador.id) } });
    itens.push(app.online ? { rotulo: 'Leiloar entre os técnicos', acao: 'leiloar', dados: { id: String(jogador.id) } } : { rotulo: 'Leiloar entre os técnicos', desativado: 'Só no modo online' });
    itens.push({ rotulo: 'Pôr para empréstimo', desativado: 'Ainda não existe no jogo' });
    itens.push({ rotulo: 'Propor contrato', desativado: 'Os contratos se renovam sozinhos' });
    itens.push({ rotulo: 'Aposentar jogador', desativado: 'Ainda não existe no jogo' });
  } else if (dono) {
    const pedido = precoPedido(jogador, dono);
    const cheio = eu.elenco.length >= ELENCO_MAX;
    const dados = { id: String(jogador.id), club: String(dono.id) };
    // jogador de outro técnico humano: a compra direta não existe (só oferta, que o dono aceita ou recusa, ou leilão)
    const deHumano = Boolean(app.online && dono.humano);
    const bloqueado = cheio ? 'Seu elenco está cheio' : '';
    itens.push({ rotulo: deHumano ? 'Fazer oferta ao técnico' : 'Fazer oferta', acao: 'oferta', dados, desativado: bloqueado || undefined });
    itens.push({ rotulo: `Comprar (${dinheiroCurto(pedido)})`, acao: 'comprar', dados, desativado: deHumano ? 'Jogador de outro técnico: faça uma oferta' : bloqueado || (eu.caixa < pedido ? 'Sem caixa para o valor pedido' : undefined) });
    itens.push({ rotulo: 'Pegar por empréstimo', desativado: 'Ainda não existe no jogo' });
  }
  return { titulo: `${jogador.nome} · ${jogador.posicao} · F:${jogador.overall}`, itens };
}

function abrirMenu(linha: HTMLElement, x: number, y: number): void {
  const m = itensDoMenu(linha);
  if (!m || m.itens.length === 0) return;
  // seleciona a linha antes de abrir (como no original) e redesenha; o menu entra depois, senão o redesenho o apagaria
  const id = Number(linha.dataset.id);
  if (linha.dataset.a === 'sel-jog') app.jogadorSel = id;
  else if (linha.dataset.a === 'times-jog') app.times.jogadorId = id;
  else if (linha.dataset.a === 'proc-sel') app.procura.sel = { jogadorId: id, clubeId: linha.dataset.club ? Number(linha.dataset.club) : null };
  desenharAgora();
  fecharMenu();
  const caixa = document.createElement('div');
  caixa.className = 'bf-ctx';
  caixa.setAttribute('role', 'menu');
  caixa.innerHTML =
    `<div class="ctx-tit">${esc(m.titulo)}</div>` +
    m.itens
      .map((it) => {
        const atributos = it.acao && !it.desativado ? ` data-a="${it.acao}" ${Object.entries(it.dados ?? {}).map(([k, v]) => `data-${k}="${esc(v)}"`).join(' ')}` : '';
        return `<button class="ctx-item" role="menuitem"${atributos} ${it.desativado ? `disabled title="${esc(it.desativado)}"` : ''}>${esc(it.rotulo)}</button>`;
      })
      .join('');
  raiz.appendChild(caixa);
  // mantém o menu dentro da janela
  const r = caixa.getBoundingClientRect();
  caixa.style.left = `${Math.max(4, Math.min(x, window.innerWidth - r.width - 4))}px`;
  caixa.style.top = `${Math.max(4, Math.min(y, window.innerHeight - r.height - 4))}px`;
  (caixa.querySelector('.ctx-item:not([disabled])') as HTMLElement | null)?.focus();
}

raiz.addEventListener('contextmenu', (ev) => {
  const linha = (ev.target as HTMLElement).closest<HTMLElement>('tr[data-a="sel-jog"], tr[data-a="times-jog"], tr[data-a="proc-sel"]');
  if (!linha || (ev.target as HTMLElement).closest('.bf-ctx')) return;
  ev.preventDefault();
  abrirMenu(linha, ev.clientX, ev.clientY);
});

// toque longo (celular): abre o mesmo menu depois de ~550 ms parado na linha
let toqueTimer: number | undefined;
let toqueOrigem: { x: number; y: number } | null = null;
raiz.addEventListener('touchstart', (ev) => {
  const linha = (ev.target as HTMLElement).closest<HTMLElement>('tr[data-a="sel-jog"], tr[data-a="times-jog"], tr[data-a="proc-sel"]');
  if (!linha || ev.touches.length !== 1) return;
  const t = ev.touches[0] as Touch;
  toqueOrigem = { x: t.clientX, y: t.clientY };
  window.clearTimeout(toqueTimer);
  toqueTimer = window.setTimeout(() => abrirMenu(linha, t.clientX, t.clientY), 550);
}, { passive: true });
raiz.addEventListener('touchmove', (ev) => {
  const t = ev.touches[0];
  if (toqueOrigem && t && Math.hypot(t.clientX - toqueOrigem.x, t.clientY - toqueOrigem.y) > 10) window.clearTimeout(toqueTimer);
}, { passive: true });
raiz.addEventListener('touchend', () => window.clearTimeout(toqueTimer));
raiz.addEventListener('touchcancel', () => window.clearTimeout(toqueTimer));

document.addEventListener('click', (ev) => {
  if (!(ev.target as HTMLElement).closest('.bf-ctx')) fecharMenu();
});
document.addEventListener('keydown', (ev) => {
  if (ev.key === 'Escape') fecharMenu();
});
window.addEventListener('scroll', fecharMenu, true);
window.addEventListener('resize', fecharMenu);

// escudo sem arquivo em public/escudos: remove a imagem quebrada e fica o círculo com as cores do clube
document.addEventListener('error', (ev) => {
  const el = ev.target;
  if (el instanceof HTMLImageElement && el.classList.contains('logo-camp')) el.remove();
  if (el instanceof HTMLImageElement && el.classList.contains('rosto-img')) {
    marcarSemRosto(el.dataset.rosto ?? '');
    const [proximo, ...resto] = (el.dataset.resto ?? '').split(',').filter(Boolean);
    if (proximo) {
      // tenta o arquivo seguinte (ex.: otavio-g.png não existe, tenta otavio.png)
      el.dataset.rosto = proximo;
      el.dataset.resto = resto.join(',');
      el.src = `./jogadores/${proximo}.png`;
    } else el.remove();
  }
  if (el instanceof HTMLImageElement && el.classList.contains('escudo-img')) {
    marcarSemEscudo(el.dataset.sigla ?? '');
    el.remove();
  }
}, true);

carregarPreferencias();
definirGanchoSalvou(selarSePreciso);
iniciarNotificacoes();
// retoma o jogo salvo (IndexedDB, assíncrono) se a pessoa ainda estiver na tela inicial quando ele chegar
void pedirPersistencia();
void carregarLocal().then((salvo) => {
  if (salvo && !app.jogo && !app.online && app.tela === 'inicio') {
    app.jogo = salvo;
    app.tela = 'jogo';
  }
  desenhar();
});
iniciarOnline({ desenhar, exibirRodada: exibirRodadaOnline });
ligarConta(desenhar);
void carregarPerfil().then(desenhar);
iniciarChat((texto) => enviar({ tipo: 'chat', texto }));
iniciarArrastar(desenharAgora);
iniciarTema();
desenhar();
